// Where a work item's screen fields are drawn, as Jira's issue view draws
// them (2026-10-07). Pure, so the rule is tested without a browser.
//
// With an issue layout (fields carry sectionType):
//   - the main column shows the CURRENT tab's content fields (and unplaced
//     fields, and Line items tables, which need the width);
//   - Details shows every tab's 'primary' fields, then every tab's
//     'secondary' ones (Parent and the like) — the sidebar stays put across
//     tab switches. Jira folds the secondary fields under "More fields";
//     Stride does not (2026-10-12): every sidebar field is in Details;
//   - a tab with nothing for the main column is not offered: all its fields
//     are already in the sidebar, so Jira does not show the tab, and Stride
//     showed an empty "No description fields configured" page under it.
// Without one, every tab is offered and the caller lays the tab out flat.

// Line items tables and Whiteboards need the width: always the main column.
export const isContentField = (f) => f.sectionType === 'content' || !f.sectionType || f.editorType === 'lineitems' || f.editorType === 'whiteboard';

export function hasLayoutSections(tabs) {
  return (tabs || []).some(tab => (tab.fields || []).some(f => f.sectionType));
}

// Indexes (into `tabs`) of the tabs a reader can choose between.
export function bodyTabIndexes(tabs) {
  const list = tabs || [];
  if (!hasLayoutSections(list)) return list.map((_, i) => i);
  return list.map((t, i) => ((t.fields || []).some(isContentField) ? i : -1)).filter(i => i >= 0);
}

// The sidebar: { details }, each field once — the primary fields in tab then
// field order, then the secondary ones in the same order.
export function sidebarFields(tabs) {
  const seen = new Set();
  const primary = []; const secondary = [];
  for (const tab of (tabs || [])) {
    for (const f of (tab.fields || [])) {
      if (f.editorType === 'lineitems' || f.editorType === 'whiteboard') continue;
      if (f.sectionType !== 'primary' && f.sectionType !== 'secondary') continue;
      if (seen.has(f.key)) continue;
      seen.add(f.key);
      (f.sectionType === 'primary' ? primary : secondary).push(f);
    }
  }
  return { details: [...primary, ...secondary] };
}
